/**
 * The two pieces every "translate with AI" surface shares: the glyph on the
 * button, and the one-line toast that reports what happened. Pulled out of
 * `TranslateWithAi` when the Topics dialog grew a translate button of its own.
 */

export function ToastLine({ message, ok }: { message: string; ok: boolean }) {
  return (
    <div className="pointer-events-none fixed top-3.5 right-0 left-0 z-[60] flex justify-center">
      <span
        role="status"
        className="inline-flex max-w-[90vw] items-center gap-2 rounded-full border px-4 py-2 text-[12.5px]"
        style={{
          background: 'var(--panel)',
          borderColor: ok ? 'var(--ok)' : 'var(--danger)',
          color: 'var(--text)',
          boxShadow: '0 16px 40px rgba(0, 0, 0, 0.55)',
        }}
      >
        <span
          aria-hidden="true"
          className="flex h-4 w-4 items-center justify-center rounded-full text-[10px] font-bold"
          style={{ background: ok ? 'var(--ok)' : 'var(--danger)', color: 'var(--on-accent)' }}
        >
          {ok ? '✓' : '!'}
        </span>
        {message}
      </span>
    </div>
  );
}

/** The design's translate glyph; spins while a run is in flight. */
export function Glyph({ spinning, size = 13 }: { spinning: boolean; size?: number }) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={spinning ? 'animate-spin' : undefined}
    >
      <path d="M2.6 6.2h7.6M6.1 4.2v2M8 6.2c-.5 3.4-2.6 5.6-5.4 6.6M4.6 9.1c.9 1.9 2.6 3.1 5 3.6" />
      <path d="M10.4 17.2l3.3-8 3.3 8M11.7 14.4h4.1" />
    </svg>
  );
}
